// eslint-disable-next-line import/prefer-default-export
export function buildOrigin(type, id) {
  if (!type || !id) return null;
  return `${type}:${id}`;
}
